import React, { Component } from 'react'
import PropTypes from 'prop-types'
import CSSModules from 'react-css-modules'
import { Flex, Box } from 'reflexbox'
import { Element } from 'react-scroll'

import SubstituteSection from 'containers/User/SubstituteSection/index'

import styles from './styles.scss'

class MainPanel extends Component {
  render() {
    return (
      <Flex id='scrollContainer' column auto styleName='mainPanel'>
        <Element name='Substitutes'>
          <SubstituteSection/>
        </Element>
        <Box auto/>
      </Flex>
    )
  }
}

export default CSSModules(MainPanel, styles)
